import { authRequest } from '@/lib/deep-mining/request';

export const getSpaceMembersList = async (params: {
  page_no: number;
  page_size: number;
  keyword: string;
}) => {
  const { page_no, page_size, keyword } = params;
  return authRequest(
    `/auth/space/members?page_no=${page_no}&page_size=${page_size}&keyword=${keyword}`,
  );
};

export const getSpaceStatistics = async () => {
  return authRequest<SPACE.Statistics>(`/auth/space/statistics`);
};

export const deleteSpaceMembers = async (params: { account_id: string }) => {
  const { account_id } = params;
  return authRequest(`/auth/space/members_manage/${account_id}`, {
    method: 'delete',
  });
};

export const createSpaceInvites = async (params: {
  expire_type: string;
  expire_time?: string;
}) => {
  return authRequest(`/auth/space/invite`, {
    method: 'post',
    body: JSON.stringify(params),
  });
};

export const getAuthorizeRoles = async () => {
  return authRequest(`/auth/authorize/roles`);
};

export const updateAuthorizeRoles = async (params: {
  account_id: string;
  role_id?: string;
}) => {
  return authRequest(`/auth/authorize/user_roles`, {
    method: 'put',
    body: JSON.stringify(params),
  });
};

export const getSpaceUserUsageDetails = async (params: {
  page_no: number;
  page_size: number;
  keyword?: string;
  start_date: string;
  end_date: string;
}) => {
  return authRequest(`/business/points/user/transactions`, {
    method: 'post',
    body: JSON.stringify(params),
  });
};

export const getSpaceUserUsageStatistics = async (params: {
  page_no: number;
  page_size: number;
  keyword?: string;
  start_date?: string;
  end_date?: string;
  order_by?: string;
  order?: string;
}) => {
  return authRequest(`/business/points/space/transactions`, {
    method: 'post',
    body: JSON.stringify(params),
  });
};

export const getSpaceAllResources = async () => {
  return authRequest(`/auth/space/all_space_resources`);
};

export const getSpaceDetail = async () => {
  return authRequest<SPACE.Detail>(`/auth/space/detail`);
};

export const createSpace = async (params: {
  space_name: string;
  contact_name: string;
  contact_phone: string;
  verify_code: string;
}) => {
  return authRequest(`/auth/space/create`, {
    method: 'post',
    body: JSON.stringify(params),
  });
};

export const verifySpaceCount = async (params: { phone: string }) => {
  const { phone } = params;
  return authRequest(`/auth/space/verify_space_count?phone=${phone}`);
};

export const getSpacePoints = async () => {
  return authRequest(`/business/points/balance`);
};

export const getUserPointsDetails = async (params: {
  page_no: number;
  page_size: number;
}) => {
  const { page_no, page_size } = params;
  return authRequest(
    `/business/points/transactions?page_no=${page_no}&page_size=${page_size}`,
  );
};

export const checkAccountExists = async (phone: string) => {
  try {
    const response = await verifySpaceCount({
      phone: phone.includes('@') ? '' : phone,
    });

    return { exists: response?.result };
  } catch (error) {
    console.error('检查账号出错:', error);
    return { exists: false };
  }
};

export const updateSpaceConfig = async (params: {
  config: {
    agent: string[];
  };
}) => {
  return authRequest(`/business/space`, {
    method: 'put',
    body: JSON.stringify(params),
  });
};
